import { AnnouncementModalLayout, Text } from '@wix/design-system';
import React, { useEffect } from 'react';
import UpgradeToPremiumIllustration from '../../assets/images/upgradeSite.svg';
import { upgradeSiteLink } from '../../consts';
import { reportModalCtaClick, reportModalShown } from '../../bi/bi';
import { Modals } from '../../types';
import { useLibraryTranslations } from '../../context/TranslationsContext';
import { useInstallerContext } from '../../context/InstallerContext';
import { useModalsAndWindow } from '../../context/ModalsAndWindowContext';
export const UpgradeToPremium = () => {
  const {
    t
  } = useLibraryTranslations();
  const {
    modals
  } = useModalsAndWindow();
  const {
    tenantId,
    preInstallationData: {
      app
    }
  } = useInstallerContext();
  useEffect(() => {
    reportModalShown(Modals.upgradeToPremium);
  }, []);
  const upgradeText = t('upgrade-to-premium.description');
  return /*#__PURE__*/React.createElement(AnnouncementModalLayout, {
    theme: "premium",
    dataHook: "upgrade-to-premium-modal-layout",
    illustration: /*#__PURE__*/React.createElement(UpgradeToPremiumIllustration, null),
    title: t('upgrade-to-premium.title', {
      appName: app == null ? void 0 : app.name
    }),
    primaryButtonText: t('upgrade-to-premium.upgrade-button'),
    primaryButtonOnClick: () => {
      const url = upgradeSiteLink(tenantId);
      reportModalCtaClick({
        ctaName: 'upgrade button',
        modalType: Modals.upgradeToPremium
      });
      window.open(url);
      modals.upgradeToPremium.close({
        answer: 'UPGRADE_TO_PREMIUM'
      });
    },
    onCloseButtonClick: () => {
      reportModalCtaClick({
        ctaName: 'close',
        modalType: Modals.upgradeToPremium
      });
      modals.upgradeToPremium.close({
        answer: 'UPGRADE_TO_PREMIUM'
      });
    }
  }, /*#__PURE__*/React.createElement(Text, null, upgradeText));
};
//# sourceMappingURL=UpgradeToPremium.js.map